<template>
  <BModal :active="isVisible" @close="$emit('close')">
    <div class="table-container">
      <table>
        <tr class="row-primary header">
          <th v-for="(header, index) of headers" :key="`h${index}`">
            <div>
              <p>
                {{ header }}
              </p>
            </div>
          </th>
        </tr>
        <tr v-for="(game, index) of formattedGames" :key="`g${index}`" class="table-body">
          <td>
            <div class="table-teams">
              <img :src="game.teams.homeTeamLogo" alt="" />
              <span>vs</span>
              <img :src="game.teams.awayTeamLogo" alt="" />
            </div>
          </td>
          <template v-if="game.status === 4">
            <td class="pre-match" colspan="6">
              <div>
                <p>
                  Partido por jugarse -&nbsp;<span>{{
                    new Date(game.dateTimeUTC) | formattedDate('EEEE d MMMM')
                  }}</span>
                </p>
              </div>
            </td>
          </template>
          <template v-else>
            <td v-for="(key, index2) of gameDataKeys" :key="`v${index2}`">
              <div>
                {{ game[key] }}
              </div>
            </td>
          </template>
        </tr>
        <tr class="row-primary table-footer">
          <th>
            <div>
              Promedio:
            </div>
          </th>
          <th v-for="(key, index) of averageDataKeys" :key="`f${index}`">
            <div>
              {{ averages[key] }}
            </div>
          </th>
        </tr>
      </table>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'ActiveTimeByMatchDay',
  components: {
    BModal: async () => {
      const { BModal } = await import('buefy/dist/esm/modal');
      return BModal;
    },
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    games: {
      type: Array,
      default: () => [],
    },
    averages: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      headers: [
        'Partido',
        'Tiempo Efectivo',
        'Duración Total',
        `% Tiempo Efectivo /\nDuración total`,
        '% Tiempo Efectivo /\n90 mins',
        '% Tiempo\nAgregado 1T',
        '% Tiempo\nAgregado 2T',
      ],
      gameDataKeys: ['activeTime', 'totalDuration', 'tePercentTotal', 'tePercent90', 'ta1t', 'ta2t'],
      averageDataKeys: [
        'te',
        'total_duration',
        'te_average',
        'te_90min_average',
        'additional_time_1t',
        'additional_time_2t',
      ],
    };
  },
  computed: {
    formattedGames() {
      return this.games.map(game => {
        return {
          teams: {
            homeTeamLogo: game.home_team_logo,
            awayTeamLogo: game.away_team_logo,
          },
          activeTime: game.te,
          totalDuration: game.total_duration,
          tePercentTotal: game.te_average,
          tePercent90: game.te_90min_average,
          ta1t: game.additional_time_1t,
          ta2t: game.additional_time_2t,
          status: game.game_status,
          dateTimeUTC: game.date_time_utc,
        };
      });
    },
  },
  methods: {
    getTimeToSeconds(timeString) {
      const dotIndex = timeString.indexOf('.');
      const stringAux = dotIndex > -1 ? timeString.substring(0, timeString.indexOf('.')) : timeString;
      const [seconds, minutes, hours] = stringAux.split(':').reverse();

      return (hours ? Number(hours) * 60 * 60 : 0) + Number(minutes) * 60 + Number(seconds);
    },
    getSecondsToTime(seconds) {
      const minutes = Math.floor(seconds / 60);
      const secondsRemaining = seconds - minutes * 60;
      const secondsPrefix = secondsRemaining < 10 ? '0' : '';
      return `${minutes}:${secondsPrefix}${Math.ceil(secondsRemaining)}`;
    },
  },
};
</script>

<style scoped lang="scss">
.table-container {
  background-color: white;
  padding: 1em;
  border-radius: 8px;

  & .row-primary {
    background-color: #52a0fc !important;
    font-family: Avenir-Bold, sans-serif;
    font-size: 11px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.36;
    letter-spacing: -0.22px;

    & > th {
      color: white;
      text-align: center;
      padding: 1em;

      & div > p {
        white-space: pre-wrap;
      }
    }
  }

  table {
    width: 100%;
    min-width: 928px;

    & tr.header {
      & > th {
        &:first-child {
          border-top-left-radius: 8px;
        }
        &:last-child {
          border-top-right-radius: 8px;
        }
      }
    }

    & tr.table-body {
      & > td {
        font-size: 13px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.15;
        letter-spacing: -0.26px;

        &.pre-match {
          & > div {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            & > p > span {
              text-transform: capitalize;
            }
          }
        }

        & > div.table-teams {
          & > img {
            margin: 0 1em;
          }

          & > span {
            font-size: 19px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 0.79;
            letter-spacing: -0.38px;
          }
        }
      }
    }

    & tr.table-footer {
      & > th {
        &:first-child {
          border-bottom-left-radius: 8px;
        }
        &:last-child {
          border-bottom-right-radius: 8px;
        }
      }
    }

    & tr {
      & > td {
        &:first-child {
          border-left: 1px solid #c1c6d1;
        }
        &:last-child {
          border-right: 1px solid #c1c6d1;
        }
      }
    }
  }

  td {
    & > div {
      min-height: 2.5em;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  tr:nth-child(odd) {
    background-color: #f3f7f9;
  }

  table td + td {
    border-left: 1px solid #c1c6d1;
  }

  table th + th {
    border-left: 1px solid #c1c6d1;
  }

  .table-teams {
    display: flex;
    justify-content: center;
    align-items: center;

    & > img {
      height: 20px;
      width: 20px;
    }
  }
}
</style>
